// extracted by mini-css-extract-plugin
module.exports = {"item":"RadioGroup_item__GRso4","item__root":"RadioGroup_item__root__SjOzK","item__indicator":"RadioGroup_item__indicator__Nk0QO","item__label":"RadioGroup_item__label__h1jno"};